/** Canonical form of an invite code: trimmed, uppercase. */
export function normalizeInviteCode(raw: string): string {
  return raw.trim().toUpperCase()
}

/**
 * Client-side format check — 7 alphanumeric characters (already normalized).
 * Existence is the server's call; this only gates obviously malformed input.
 */
export function isValidInviteCode(code: string): boolean {
  return /^[A-Z0-9]{7}$/.test(code)
}
